import React, { useState, useEffect } from 'react';
import './App.css';
import CalendarComponent from './Calendar';

function App() {
  const [testDate, setTestDate] = useState('Loading...');
  
  // Fetch the date from the API
  useEffect(() => {
    const fetchTestDate = async () => {
      try {
        const response = await fetch('/api/testrun');
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        
        const data = await response.json();
        if (data && data.date) {
          setTestDate(data.date);
        } else {
          setTestDate('No date found');
        }
      } catch (error) {
        console.error('Error fetching date:', error);
        setTestDate('Error loading date');
      }
    };
    
    fetchTestDate();
  }, []);
  
  return (
    <div className="App">
      <header className="App-header">
        <h1>Schedulio</h1>
      </header>
      <div className="test-data">
        <p>Date from database (ID=3): <strong>{testDate}</strong></p>
      </div>
      <main>
        <CalendarComponent />
      </main>
    </div>
  );
}

export default App;
